var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "hero is-medium" }, [
    _c("div", { staticClass: "hero-body" }, [
      _c("div", { staticClass: "content container has-text-centered" }, [
        _c("h1", { staticClass: "title is-1" }, [_vm._v("Error")]),
        _vm._v(" "),
        _c("h1", { staticClass: "subtitle is-6" }, [
          _vm._v(
            "Ha ocurrido un error en el servidor. Ante la duda, reporte el inconveniente."
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "button is-dark",
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [_vm._v("Volver atras")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }